import actions from '../../actions-list';

export const updateIsInitialLoad = isInitialLoad =>

    dispatch => {

        dispatch({
            isInitialLoad,
            type: actions.UPDATE_REIMBURSEMENT_SUMMARY_IS_INITIAL_LOAD
        });

    };



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/action-creators/is-initial-load.js